module.exports = "<input \ntype=\"file\"\nngf-select\nng-model=\"fileToUpload\"\nstyle=\"position: absolute; left: -10000em;\">\n";